
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">RX Panoramica</h4><span class="text-muted mt-1 tx-13 ms-2 mb-0">/
    Inicio</span>
  </div>
</div>
</div>

<div class="row">
  <div class="col-md-12 col-xl-12 col-xs-12 col-sm-12">
    <!--div-->
    <div class="card">
      <div class="card-body">
        <div class="main-content-label mg-b-5">
          Filtrar
        </div>
        <!-- <p class="mg-b-20">It is Very Easy to Customize and it uses in your website apllication.</p> -->
        <div class="row row-sm">
          <div class="col-lg">
            <label for="">Desde</label>
            <input class="form-control" [(ngModel)]="fechaInicio" min="2023-05-01" type="date">
          </div>
          <div class="col-lg">
            <label for="">Hasta</label>
            <input class="form-control" [(ngModel)]="fechaFin" min="2023-05-01"  type="date">
          </div>
          <div class="col-lg">
            <label for="">Estado</label>
            <ng-select  [searchable]="false"  [(ngModel)]="estadoFiltro"  class="form-control">
              <ng-option value="pendiente">Pendientes</ng-option>
              <ng-option value="atendidas">Atendidas</ng-option>
              <!-- <ng-option value="con-imagenes">Imagenes Doctor</ng-option> -->
            </ng-select>
          </div>
          <div class="col-lg-1">
            <label for="">Filtrar</label>
            <button type="button" class="btn btn btn-dark" (click)="filtrarPanoramicaFechas()">
              Buscar <i class="fe fe-plus-circle"></i>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<div class="row">
  <div class="col-md-12 col-xl-12 col-xs-12 col-sm-12">

    @if (spinnerBoolean) {
      <div class="text-center">
        <div class="spinner-grow" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <br>
        </div>
      }
      <!--div-->
      <div class="card">
        <div class="card-body">
          <div class="row align-items-center mb-3">
            <div class="col-sm-6 d-flex align-items-center">
              <label class="mb-0 me-2" for="limitePanoramica">Mostrar</label>
              <select
                id="limitePanoramica"
                class="form-control form-control-sm"
                style="width: 75px;"
                [ngModel]="limite"
                (ngModelChange)="cambiarLimite($event)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
              </select>
              <span class="ms-2">registros</span>
            </div>
            <div class="col-sm-6 d-flex align-items-center justify-content-end">
              <label class="mb-0 me-2" for="buscarPanoramica">Buscar:</label>
              <input
                id="buscarPanoramica"
                type="search"
                class="form-control form-control-sm"
                style="max-width: 240px;"
                [ngModel]="busqueda"
                (ngModelChange)="programarBusqueda($event)">
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped table-hover dt-ext">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Factura</th>
                  <th>Nº Orden</th>
                  <th>Paciente</th>
                  <th>Celular Paciente</th>
                  <th>Fec. Nacimiento Paciente</th>
                  <th>Cod. Doctor</th>
                  <th>Doctor</th>
                  <th>Sucursal</th>
                  <th>Fecha de registro</th>
                  <th>Tipo</th>
                  <th>Responsable</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (dt of ordenes; track dt.COD_ORD; let rowIndex = $index) {
                  <tr>
                    <td>{{pagina + rowIndex + 1}}</td>
                    <td>{{dt.numeroFacturaOrden}}</td>
                    <td>
                      <div class="text-center">{{dt.NUM_ORD}}</div>
                      @if (dt.secuenciaOrden != null && dt.secuenciaOrden != 'null' && dt.secuenciaOrden != '') {
                        <div class="text-center">
                          <b>SF:</b>
                          <p class="text-success">{{dt.secuenciaOrden}}</p>
                        </div>
                      }
                    </td>
                    <td>{{dt.NOM_CLI}}</td>
                    <td>{{dt.TEL_CLI}}</td>
                    <td>
                      @if (dt.FEC_CLI !== null && dt.FEC_CLI !== '' && dt.FEC_CLI !== 'null') {
                        <div class="text-center">{{dt.FEC_CLI}}</div>
                      } @else {
                        <div class="text-center text-danger">NO ESTABLECIDO</div>
                      }
                    </td>
                    <td>{{dt.CODN_DOC}}</td>
                    <td>{{dt.NOM_DOC}}</td>
                    <td>{{dt.DIR_SURC}}</td>
                    <td>{{dt.fecha}}</td>
                    <td>
                      @if (dt.tipo === 'WEB') {
                        <div class="text-center"><i class="fa fa-laptop text-primary"></i> WEB</div>
                      }
                      @if (dt.tipo === 'MOVIL') {
                        <div class="text-center"><i class="fa fa-mobile text-primary"></i> MOVIL</div>
                      }
                    </td>
                    <td>{{dt.responsable}}</td>
                    <td>
                      <div ngbDropdown>
                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                          <i class="fe fe-settings"></i>
                        </button>
                        <div class="tx-13" ngbDropdownMenu>
                          <a ngbDropdownItem href="javascript:;" (click)="subirImagenes(dt.COD_ORD)">
                            <i class="far fa-file-image text-primary" aria-hidden="true"></i>
                            <b>&nbsp;&nbsp;AÑADIR NUEVAS IMÁGENES</b>
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
                @if (!spinnerBoolean && ordenes.length === 0) {
                  <tr>
                    <td colspan="13" class="text-center">No se encontraron registros</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div class="row align-items-center mt-3">
            <div class="col-sm-6">
              Mostrando desde {{registroInicial}} al {{registroFinal}}
              de {{recordsFiltered}} elementos
              @if (recordsFiltered !== recordsTotal) {
                <span>(filtrado de {{recordsTotal}} elementos totales)</span>
              }
            </div>
            <div class="col-sm-6">
              <nav aria-label="Paginación de órdenes panorámicas">
                <ul class="pagination pagination-sm justify-content-end mb-0">
                  <li class="page-item" [class.disabled]="paginaActual === 1">
                    <button class="page-link" type="button" (click)="irPagina(1)" [disabled]="paginaActual === 1">Primero</button>
                  </li>
                  <li class="page-item" [class.disabled]="paginaActual === 1">
                    <button class="page-link" type="button" (click)="irPagina(paginaActual - 1)" [disabled]="paginaActual === 1">Ant</button>
                  </li>
                  @for (numeroPagina of paginasVisibles; track numeroPagina) {
                    <li class="page-item" [class.active]="numeroPagina === paginaActual">
                      <button class="page-link" type="button" (click)="irPagina(numeroPagina)">{{numeroPagina}}</button>
                    </li>
                  }
                  <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
                    <button class="page-link" type="button" (click)="irPagina(paginaActual + 1)" [disabled]="paginaActual === totalPaginas">Sig</button>
                  </li>
                  <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
                    <button class="page-link" type="button" (click)="irPagina(totalPaginas)" [disabled]="paginaActual === totalPaginas">Último</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
    </div>
  </div>
</div>
</div>
